import React from 'react'
import Label from 'src/components/riders/rider-portal/common/Label'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

interface IServiceAndProductProps {
  product: string
  service: string
}

const ServiceAndProduct = ({ product, service }: IServiceAndProductProps) => {
  const { product: productLabel, service: serviceLabel } = RIDER_PORTAL_UI_MESSAGES.common
  return (
    <div>
      <h4 className='font-black3 font-medium rp-mb8 rp-my0 text-center text-md'>{`${serviceLabel} and ${productLabel}`}</h4>
      <div className='flex column-gap-12'>
        <Label text={serviceLabel} />
        <p className='font-grey8 rp-my0 rp-pt2 text-md'>{service}</p>
      </div>
      <div className='flex column-gap-12 rp-mt8'>
        <Label text={productLabel} />
        <p className='font-grey8 rp-my0 rp-pt2 text-md'>{product}</p>
      </div>
    </div>
  )
}

export default ServiceAndProduct



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/details/ServiceAndProduct.tsx